import { STATES as SELECTCORE_STATES } from "../index"

export class KeyboardPlugin {
    constructor() {
        this.keyboardHighlighted = null
    }

    options() {
        return {}
    }

    setup(inst) {
        this.inst = inst

        this.inst.element.tabIndex = 0
        this.inst.element.addEventListener("keydown", this.handleKeyDown)
    }

    handleKeyDown = (event) => {
        switch (event.code) {
            case "Enter":
                event.preventDefault()
                if (this.inst.element.classList.contains(SELECTCORE_STATES.OPEN)) {
                    if (this.keyboardHighlighted) {
                        this.inst.selectChoiceByValue(this.keyboardHighlighted.value)
                    }
                    this.inst.closeList()
                } else {
                    this.inst.openList()
                }
                break
            case "Escape":
                event.preventDefault()
                this.inst.closeList()
                break
            case "ArrowUp":
                event.preventDefault()
                this.inst.openList()
                this.highlightPrevChoice()
                break
            case "ArrowDown":
                event.preventDefault()
                this.inst.openList()
                this.highlightNextChoice()
                break
            default:
                break
        }
    }

    highlightPrevChoice() {
        const choices = this.inst.choices.filter((choice) => !choice.element.classList.contains("is-prompt") && !choice.element.classList.contains("is-disabled"))

        let index = choices.findIndex((choice) => choice === this.keyboardHighlighted) || 0
        index = index > 0 ? index - 1 : choices.length - 1
        this.highlightChoice(choices[index].id)
    }

    highlightNextChoice() {
        const choices = this.inst.choices.filter((choice) => !choice.element.classList.contains("is-prompt") && !choice.element.classList.contains("is-disabled"))

        let index = choices.findIndex((choice) => choice === this.keyboardHighlighted) || 0
        index = (index + 1) % choices.length
        this.highlightChoice(choices[index].id)
    }

    highlightChoice(choiceId) {
        this.inst.choices.forEach((choice) => {
            if (choice.id === choiceId) {
                choice.element.classList.add("is-active")
                this.keyboardHighlighted = choice
                this.scrollChoiceToCenter(choice)
            } else {
                choice.element.classList.remove("is-active")
            }
        })
    }

    scrollChoiceToCenter(choice) {
        if (!choice) {
            return
        }

        const itemHeight = choice.element.scrollHeight
        const listHeight = this.inst.ref.list.offsetHeight
        const itemOffset = choice.element.offsetTop

        this.inst.ref.list.scrollTo({
            left: 0,
            top: itemOffset - listHeight / 2 + itemHeight / 2,
            behavior: "auto",
        })
    }
}
